import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import Maintenance from "../views/Maintenance.vue";
import TwoFAService from "@/services/twoFA.service";
import { config } from "../config";
import { APPROVAL_ACLS } from "../config/approvals";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      component: Login,
      meta: {
        tabLabel: "Login",
      },
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: Maintenance,
    },
    {
      path: "/",
      name: "home",
      meta: {
        tabLabel: "Início",
      },
      // lazy-loaded
      component: () => import("../views/Home.vue"),
    },
    {
      path: "/my-work",
      name: "my-work",
      meta: {
        tabLabel: "O Que Tenho a Fazer",
      },
      component: () => import("../views/MyWork.vue"),
    },
    {
      path: "/profile",
      name: "profile",
      meta: {
        tabLabel: "Perfil",
      },
      // lazy-loaded
      component: () => import("../views/Profile.vue"),
    },
    {
      path: "/hours",
      name: "hours",
      // lazy-loaded
      component: () => import("../views/Hours.vue"),
    },
    {
      path: "/vacations",
      name: "vacations",
      // lazy-loaded
      component: () => import("../views/Vacations.vue"),
    },
    {
      path: "/vacations-department",
      name: "vacations-department",
      // lazy-loaded
      component: () => import("../views/VacationsDepartments.vue"),
    },
    {
      path: "/vacations-collaborators-summary",
      name: "vacations-collaborators-summary",
      meta: {
        permissions: "seeVacationMap",
      },
      // lazy-loaded
      component: () => import("../views/VacationsCollaboratorsSummary.vue"),
    },
    {
      path: "/open-days-summary",
      name: "open-days-summary",
      meta: {
        permissions: "seeOpenDaysSummary",
      },
      // lazy-loaded
      component: () => import("../views/OpenDaysSummary.vue"),
    },
    {
      path: "/approvals",
      name: "approvals",
      // lazy-loaded
      component: () => import("../views/ApprovalsHub.vue"),
      meta: {
        // Each item inside is gated by the aliases of its old menu item, so
        // any of them opens the page.
        permissionsAny: APPROVAL_ACLS,
        tabLabel: "Aprovações",
      },
    },
    // Now an item of the «Aprovações» hub.
    {
      path: "/vacations-approve",
      redirect: (to) => ({ path: "/approvals", query: { ...to.query, dom: "ferias" } }),
    },
    {
      path: "/expenditure/:status?",
      name: "expenditure",
      // lazy-loaded
      component: () => import("../views/Expenditure.vue"),
    },
    // Now an item of the «Aprovações» hub.
    {
      path: "/expenditure-approve",
      redirect: (to) => ({ path: "/approvals", query: { ...to.query, dom: "despesas" } }),
    },
    {
      path: "/expenditure-report",
      name: "expenditure-report",
      // lazy-loaded
      component: () => import("../views/ExpenditureReport.vue"),
    },
    {
      path: "/miss",
      name: "miss",
      // lazy-loaded
      component: () => import("../views/Miss.vue"),
    },
    // Now an item of the «Aprovações» hub.
    {
      path: "/miss-approve",
      redirect: (to) => ({ path: "/approvals", query: { ...to.query, dom: "faltas" } }),
    },
    {
      path: "/miss-all",
      name: "miss-all",
      // lazy-loaded
      component: () => import("../views/MissAllList.vue"),
      meta: { permissions: "seeOthersMiss" },
    },
    {
      path: "/support",
      name: "support",
      // lazy-loaded
      component: () => import("../views/Support.vue"),
    },
    {
      path: "/suppliers",
      name: "suppliers",
      meta: {
        permissions: "seeSuppliers",
      },
      component: () => import("../views/Suppliers.vue"),
    },
    {
      path: "/supplier-details/:no",
      name: "supplier-details",
      meta: {
        permissions: "seeSuppliers",
      },
      component: () => import("../views/SupplierDetails.vue"),
    },
    {
      path: "/surveys/:status?",
      name: "surveys",
      // lazy-loaded
      component: () => import("../views/Surveys.vue"),
    },
    {
      path: "/project-comments-view/:id",
      name: "project-comments-view",
      // lazy-loaded
      component: () => import("../views/ProjectCommentsView.vue"),
    },
    {
      path: "/installations-witchout-report",
      name: "installations-witchout-report",
      // lazy-loaded
      component: () => import("../views/InstallationsWitchoutReport.vue"),
    },
    {
      path: "/installations-witch-report",
      name: "installations-witch-report",
      // lazy-loaded
      component: () => import("../views/InstallationsWitchReport.vue"),
    },
    {
      path: "/task-installation-sheet/:taskId/:idInstallations?",
      name: "task-installation-sheet",
      // lazy-loaded
      component: () => import("../views/TaskInstallationSheet.vue"),
    },
    {
      path: "/satisfaction-form-installations",
      name: "satisfaction-form-installations",
      // lazy-loaded
      component: () => import("../views/SatisfactionFormInstallations.vue"),
    },
    {
      path: "/satisfaction-form-installations-quiz/:id",
      name: "satisfaction-form-installations-quiz",
      // lazy-loaded
      component: () => import("../views/SatisfactionFormInstallationsQuiz.vue"),
    },
    {
      path: "/satisfaction-form-support",
      name: "satisfaction-form-support",
      // lazy-loaded
      component: () => import("../views/SatisfactionFormSupport.vue"),
    },
    {
      path: "/satisfaction-form-support-quiz/:id",
      name: "satisfaction-form-support-quiz",
      // lazy-loaded
      component: () => import("../views/SatisfactionFormSupportQuiz.vue"),
    },
    {
      path: "/users-info",
      name: "users-info",
      // lazy-loaded
      component: () => import("../views/UsersInfo.vue"),
    },
    {
      path: "/users-info-view/:id",
      name: "users-info-view",
      // lazy-loaded
      component: () => import("../views/UsersInfoView.vue"),
    },
    {
      path: "/employee-equipment",
      name: "employee-equipment",
      // lazy-loaded
      component: () => import("../views/EmployeeEquipment.vue"),
    },
    {
      path: "/my-equipment",
      name: "my-equipment",
      // lazy-loaded
      component: () => import("../views/MyEquipment.vue"),
    },
    {
      path: "/satisfaction-form-installations-export",
      name: "satisfaction-form-installations-export",
      // lazy-loaded
      component: () =>
        import("../views/SatisfactionFormInstallationsExport.vue"),
    },
    {
      path: "/satisfaction-form-support-export",
      name: "satisfaction-form-support-export",
      // lazy-loaded
      component: () => import("../views/SatisfactionFormSupportExport.vue"),
    },
    {
      path: "/satisfaction-form-resume",
      name: "satisfaction-form-resume",
      // lazy-loaded
      component: () => import("../views/SatisfactionFormResume.vue"),
    },
    {
      path: "/disclosure",
      name: "disclosure",
      // lazy-loaded
      component: () => import("../views/Disclosure.vue"),
    },
    {
      path: "/disclosure-view/:id",
      name: "disclosure-view",
      // lazy-loaded
      component: () => import("../views/DisclosureView.vue"),
    },
    {
      path: "/competency-profile",
      name: "competency-profile",
      // lazy-loaded
      component: () => import("../views/CompetencyProfile.vue"),
    },
    {
      path: "/competency-profile-resume",
      name: "competency-profile-resume",
      // lazy-loaded
      component: () => import("../views/CompetencyProfileResume.vue"),
    },
    {
      path: "/competency-profile-user",
      name: "competency-profile-user",
      // lazy-loaded
      component: () => import("../views/CompetencyProfileUser.vue"),
    },
    {
      path: "/competency-profile-user/:userId/:username",
      // lazy-loaded
      component: () => import("../views/CompetencyProfileUser.vue"),
    },
    {
      path: "/competency-profile-view/:id",
      name: "competency-profile-view",
      // lazy-loaded
      component: () => import("../views/CompetencyProfileView.vue"),
    },
    {
      path: "/useful-links",
      name: "useful-links",
      // lazy-loaded
      component: () => import("../views/LinksUseful.vue"),
    },
    {
      path: "/useful-links-categories",
      name: "useful-links-categories",
      // lazy-loaded
      component: () => import("../views/LinksUsefulCategories.vue"),
    },
    {
      path: "/useful-links-users",
      name: "useful-links-users",
      // lazy-loaded
      component: () => import("../views/LinksUsefulUsers.vue"),
    },
    {
      path: "/product-search",
      name: "product-search",
      // lazy-loaded
      component: () => import("../views/ProductSearch.vue"),
    },
    {
      path: "/pat-details2/:id",
      name: "pat-details2",
      // lazy-loaded
      component: () => import("../views/PatDetails2.vue"),
    },
    {
      path: "/pats-list",
      name: "pats-list",
      meta: {
        permissions: "seePatsList",
      },
      component: () => import("../views/PatsList.vue"),
    },
    {
      path: "/unidash-occurrences",
      name: "unidash-occurrences",
      meta: {
        permissions: "seeUnidashOccurrences",
        tabLabel: "Ocorrências Unidashboard",
      },
      component: () => import("../views/UnidashOccurrences.vue"),
    },
    {
      path: "/unidash-occurrences/:id",
      name: "unidash-occurrence-detail",
      meta: {
        permissions: "seeUnidashOccurrences",
      },
      component: () => import("../views/UnidashOccurrenceDetail.vue"),
    },
    {
      path: "/my-team-pats",
      name: "my-team-pats",
      meta: {
        permissions: "seeMyTeamPats",
      },
      component: () => import("../views/MyTeamPats.vue"),
    },
    {
      path: "/internal-pats",
      name: "internal-pats",
      meta: { permissions: "seeInternalPats" },
      component: () => import("../views/InternalPatsList.vue"),
    },
    {
      path: "/interventions-list",
      name: "interventions-list",
      meta: { permissions: "viewPatInterventions" },
      component: () => import("../views/InterventionsList.vue"),
    },
    {
      path: "/intervention-detail/:id",
      name: "intervention-detail",
      meta: { permissions: "viewPatInterventions" },
      component: () => import("../views/InterventionDetail.vue"),
    },
    {
      path: "/support-map",
      name: "support-map",
      // lazy-loaded
      component: () => import("../views/SupportMap.vue"),
    },
    {
      path: "/nok-map",
      name: "nok-map",
      meta: { permissions: "accessUnidashNok", tabLabel: "Mapa de Avarias" },
      // lazy-loaded
      component: () => import("../views/NokMap.vue"),
    },
    {
      path: "/support-map/:date",
      // name: 'support-map',
      // lazy-loaded
      component: () => import("../views/SupportMap.vue"),
    },
    {
      path: "/search/:term",
      //name: 'search',
      // lazy-loaded
      component: () => import("../views/Search.vue"),
    },
    {
      path: "/search/",
      name: "search",
      // lazy-loaded
      component: () => import("../views/Search.vue"),
    },
    {
      path: "/training/",
      name: "training",
      // lazy-loaded
      component: () => import("../views/TrainingActions.vue"),
    },
    {
      path: "/training-needs/",
      name: "training-needs",
      // lazy-loaded
      component: () => import("../views/TrainingNeeds.vue"),
    },
    {
      path: "/my-training/",
      name: "my-training",
      // lazy-loaded
      component: () => import("../views/TrainingParticipation.vue"),
    },
    {
      path: "/training-resume/",
      name: "training-resume",
      // lazy-loaded
      component: () => import("../views/TrainingResume.vue"),
    },
    {
      path: "/interview-sheet/",
      name: "interview-sheet",
      // lazy-loaded
      component: () => import("../views/InterviewSheet.vue"),
    },
    {
      path: "/interview-sheet-view/:interviewId",
      // lazy-loaded
      component: () => import("../views/InterviewSheetView.vue"),
    },
    {
      path: "/manuals",
      name: "manuals",
      // lazy-loaded
      component: () => import("../views/Manuals.vue"),
    },
    {
      path: "/manuals-categories",
      name: "manuals-categories",
      // lazy-loaded
      component: () => import("../views/ManualsCategories.vue"),
    },
    {
      path: "/installations/:status?",
      name: "installations",
      // lazy-loaded
      component: () => import("../views/Installations.vue"),
    },
    {
      path: "/interventions-billing",
      name: "interventions-billing",
      // lazy-loaded
      meta: {
        permissions: "seeBillInterventions",
      },
      component: () => import("../views/InterventionsBilling.vue"),
    },
    {
      path: "/reports/pat-problem-types",
      name: "pat-problem-types",
      meta: {
        permissions: "seePatProblemTypesMenu",
        twoFa: true,
      },
      component: () => import("../views/PatProblemTypes.vue"),
    },
    {
      path: "/reports/support-pats-tickets",
      name: "support-pats-tickets",
      meta: {
        permissions: "seeSupportPatsTicketsReport",
        twoFa: true,
      },
      component: () => import("../views/SupportPatsTicketsReport.vue"),
    },
    {
      path: "/reports/support-pats-tickets/:locationId",
      name: "support-pats-tickets-detail",
      meta: {
        permissions: "seeSupportPatsTicketsReport",
        twoFa: true,
      },
      component: () => import("../views/SupportPatsTicketsByLocation.vue"),
    },
    {
      path: "/reports/installations-map",
      name: "installations-map",
      meta: {
        permissions: "seeInstallationsMap",
      },
      component: () => import("../views/InstallationsMap.vue"),
    },
    {
      path: "/reports/interventions-map",
      name: "interventions-map",
      meta: {
        permissions: "seeInterventionsMap",
      },
      component: () => import("../views/InterventionsMap.vue"),
    },
    // The report used to live at /pat-problem-types; the redirects keep
    // bookmarks and links working. The route names are unchanged, so
    // navigation by name needs no edit.
    {
      path: "/pat-problem-types",
      redirect: (to) => ({ name: "pat-problem-types", query: to.query }),
    },
    {
      path: "/material",
      name: "material",
      meta: {
        permissionsAny: [
          "seeMaterialToProcess",
          "seeMaterialToOrder",
          "seeMaterialToReceive",
          "seeMaterialToReceivePending",
          "seeMaterialReceived",
          "seeMaterialOrderVsPurchase",
        ],
      },
      component: () => import("../views/Material.vue"),
    },
    {
      path: "/reports/pat-problem-types/:problemType",
      name: "pat-problem-types-detail",
      meta: {
        permissions: "seePatProblemTypesMenu",
        twoFa: true,
      },
      component: () => import("../views/PatsByProblemType.vue"),
    },
    {
      path: "/pat-problem-types/:problemType",
      redirect: (to) => ({
        name: "pat-problem-types-detail",
        params: to.params,
        query: to.query,
      }),
    },
    {
      path: "/installation-details/:id",
      name: "installation-details",
      meta: {
        tabLabel: "Detalhe da Instalação",
      },
      // lazy-loaded
      component: () => import("../views/InstallationDetail.vue"),
    },
    {
      path: "/assists/:status?",
      name: "assists",
      // lazy-loaded
      component: () => import("../views/Assists.vue"),
    },
    {
      path: "/supplier-orders",
      name: "supplier-orders",
      // lazy-loaded
      meta: {
        permissions: "seeSupplierOrders",
      },
      component: () => import("../views/SupplierOrders.vue"),
    },
    {
      path: "/suppliers-purchasing",
      name: "suppliers-purchasing",
      // lazy-loaded
      meta: {
        permissions: "seeSuppliersPurchasing",
      },
      component: () => import("../views/SuppliersPurchasing.vue"),
    },
    {
      path: "/hours-inactive-users",
      name: "hours-inactive-users",
      // lazy-loaded
      component: () => import("../views/HoursInactiveUsers.vue"),
    },
    {
      path: "/helpdesk-tickets",
      name: "helpdesk-tickets",
      meta: {
        permissions: "seeTickets",
      },
      // lazy-loaded
      component: () => import("../views/HelpdeskTickets.vue"),
    },
    {
      path: "/helpdesk-tickets-detail2/:ticketId",
      name: "helpdesk-tickets-detail2",
      // lazy-loaded
      component: () => import("../views/HelpdeskTicketsDetail2.vue"),
    },
    {
      path: "/support-teams",
      name: "support-teams",
      meta: {
        permissions: "viewSupportTeams",
      },
      component: () => import("../views/SupportTeams.vue"),
    },
    {
      path: "/proposals",
      name: "proposals",
      meta: {
        permissions: "seeProposals",
      },
      component: () => import("../views/Proposals.vue"),
    },
    {
      path: "/proposal-detail/:proposalId",
      name: "proposal-detail",
      // lazy-loaded
      component: () => import("../views/ProposalDetail.vue"),
    },
    {
      path: "/acls",
      name: "acls",
      // lazy-loaded
      component: () => import("../views/Acls.vue"),
      meta: {
        permissions: "seeAcls",
      },
    },
    {
      path: "/acls-categories",
      name: "acls-categories",
      // lazy-loaded
      component: () => import("../views/AclsCategories.vue"),
      meta: {
        permissions: "seeAclsCategories",
      },
    },
    {
      path: "/acls-groups",
      name: "acls-groups",
      // lazy-loaded
      component: () => import("../views/AclsGroups.vue"),
      meta: {
        permissions: "seeAclsGroups",
      },
    },
    {
      path: "/acls-users",
      name: "acls-users",
      // lazy-loaded
      component: () => import("../views/AclsUsers.vue"),
      meta: {
        permissions: "viewUserGroupAndAcls",
      },
    },
    {
      path: "/contacts",
      name: "contacts",
      // lazy-loaded
      component: () => import("../views/Contacts.vue"),
      // meta: {
      //   permissions: "viewUserGroupAndAcls",
      // },
    },
    {
      path: "/extranet-users",
      name: "extranet-users",
      // lazy-loaded
      component: () => import("../views/ExtranetUsers.vue"),
      meta: {
        permissions: "seeExtranetUsers",
      },
    },
    {
      path: "/extranet-temp-access",
      name: "extranet-temp-access",
      // lazy-loaded
      component: () => import("../views/ExtranetTempAccess.vue"),
      meta: {
        permissions: "seeExtranetTempAccess",
      },
    },
    {
      path: "/helpdesk-contacts",
      name: "helpdesk-contacts",
      // lazy-loaded
      component: () => import("../views/HelpdeskContacts.vue"),
      meta: {
        permissions: "seeHelpdeskContacts",
      },
    },
    {
      path: "/helpdesk-blocked-emails",
      name: "helpdesk-blocked-emails",
      // lazy-loaded
      component: () => import("../views/HelpdeskBlockedEmails.vue"),
      meta: {
        permissions: "seeBlockedEmails",
      },
    },
    {
      path: "/helpdesk-blocked-subjects",
      name: "helpdesk-blocked-subjects",
      // lazy-loaded
      component: () => import("../views/HelpdeskBlockedSubjects.vue"),
      meta: {
        permissions: "seeBlockedSubjects",
      },
    },
    {
      path: "/vehicles",
      name: "vehicles",
      // lazy-loaded
      component: () => import("../views/FleetVehicles.vue"),
      meta: {
        permissions: "seeFleetVehicles",
      },
    },
    {
      path: "/vehicle-details/:id",
      name: "vehicle-details",
      // lazy-loaded
      component: () => import("../views/FleetVehiclesDetails.vue"),
      meta: {
        permissions: "seeFleetVehicleDetails",
      },
    },
    {
      path: "/human-resources-report",
      name: "human-resources-report",
      // lazy-loaded
      component: () => import("../views/HumanResourcesReport.vue"),
      // meta: {
      //   permissions: "seeFleetVehicleDetails",
      // },
    },
    {
      path: "/time-clock-report",
      name: "time-clock-report",
      meta: {
        permissions: "seeTimeClockReport",
      },
      // lazy-loaded
      component: () => import("../views/TimeClockReport.vue"),
    },
    {
      path: "/time-clock",
      name: "time-clock",
      meta: {
        permissions: "punchTimeClock",
      },
      // lazy-loaded
      component: () => import("../views/TimeClock.vue"),
    },
    {
      path: "/attendance-map",
      name: "attendance-map",
      meta: {
        permissions: "seeAttendanceMap",
      },
      // lazy-loaded
      component: () => import("../views/AttendanceMap.vue"),
    },
    {
      path: "/crmV2",
      name: "crmV2",
      // lazy-loaded
      component: () => import("../views/crmV2.vue"),
      meta: {
        // permissions: "seeCRMV2",
        permissions: "seeCRM",
      },
    },
    {
      path: "/crm/lead/:id",
      name: "crm-lead",
      // lazy-loaded
      component: () => import("../views/CrmLead.vue"),
      meta: {
        permissions: "seeLeadCrm",
      },
    },
    {
      path: "/business-classification",
      name: "business-classification",
      // lazy-loaded
      component: () => import("../views/BusinessClassificationHub.vue"),
      meta: {
        // One page for the three old ones; each step inside is gated by its
        // own alias, so any of them opens the page.
        permissionsAny: [
          "seeBusinessClassification",
          "seeBusinessPortfolio",
          "autoClassifyBusiness",
        ],
        tabLabel: "Classificação de Negócios",
      },
    },
    // The old «Revisão IA» page is the hub's last step.
    {
      path: "/business-classification/ai-review",
      redirect: (to) => ({
        path: "/business-classification",
        query: { ...to.query, dom: "revisaoIa" },
      }),
    },
    {
      path: "/business-area",
      name: "business-area",
      // lazy-loaded
      component: () => import("../views/BusinessArea.vue"),
      meta: {
        permissions: "seeBusinessArea",
      },
    },
    {
      path: "/organization-chart",
      name: "organization-chart",
      component: () => import("../views/OrganizationChart.vue"),
      meta: {
        permissions: "seeOrganizationChart",
      },
    },
    {
      path: "/organization-chart/admin",
      name: "organization-chart-admin",
      component: () => import("../views/OrganizationChartAdmin.vue"),
      meta: {
        permissionsAny: ["manageOrganogramaProjects", "manageUserProjects"],
      },
    },
    // Notification system admin / user routes
    {
      path: "/my-notifications",
      name: "notifications-dashboard",
      component: () => import("../views/NotificationsDashboard.vue"),
    },
    {
      path: "/notifications/admin/priorities",
      name: "notification-priorities",
      meta: { permissions: "seeNotificationPriorities" },
      component: () => import("../views/NotificationPriorities.vue"),
    },
    {
      path: "/notifications/admin/tags",
      name: "notification-tags",
      meta: { permissions: "seeNotificationTags" },
      component: () => import("../views/NotificationTags.vue"),
    },
    {
      path: "/notifications/admin/alerts",
      name: "notification-alerts",
      meta: { permissions: "seeAlertConfigurations" },
      component: () => import("../views/AlertConfigurations.vue"),
    },
    {
      path: "/notifications/admin/organization",
      name: "notification-organization",
      meta: { permissions: "organizeAlertConfigurations" },
      component: () => import("../views/AlertOrganization.vue"),
    },
    {
      path: "/notifications/admin/current",
      name: "current-notifications",
      meta: { permissions: "seeCurrentNotifications" },
      component: () => import("../views/CurrentNotifications.vue"),
    },
    {
      path: "/municipal-holidays",
      name: "municipal-holidays",
      meta: { permissions: "seeMunicipalHolidays" },
      component: () => import("../views/MunicipalHolidays.vue"),
    },
    {
      path: "/administration/support-extra-technicians",
      name: "support-extra-technicians",
      meta: { permissions: "seeSupportExtraTechnicians" },
      component: () => import("../views/SupportExtraTechnicians.vue"),
    },
    {
      path: "/crm/graphics",
      name: "crm-graphics",
      // lazy-loaded
      component: () => import("../views/CrmGraphics.vue"),
      meta: {
        permissions: "seeCRMGraphics",
      },
    },
    {
      path: "/crm/admin/client-types",
      name: "crm-client-types-admin",
      // lazy-loaded
      component: () => import("../views/CrmAdminClientType.vue"),
      meta: {
        permissions: "createCrmClientTypes",
      },
    },
    {
      path: "/crm/admin/categories",
      name: "crm-categories-admin",
      // lazy-loaded
      component: () => import("../views/CrmAdminCategories.vue"),
      meta: {
        permissions: "createCrmCategories",
      },
    },
    {
      path: "/support/bookings",
      name: "support/bookings",
      // lazy-loaded
      component: () => import("../views/SupportBookings.vue"),
      meta: {
        permissions: "seeBookinglistMenu",
      },
    },
    // The old «Portfólio» page is the hub's third step.
    {
      path: "/business-portfolio",
      redirect: (to) => ({
        path: "/business-classification",
        query: { ...to.query, dom: "portfolio" },
      }),
    },
    {
      path: "/business/classification/:id",
      name: "/business-classification-view",
      // lazy-loaded
      component: () => import("../views/BusinessClassificationView.vue"),
      meta: {
        permissions: "seeBusinessPortfolio",
      },
    },
    {
      path: "/file-organizer",
      name: "file-organizer",
      // lazy-loaded
      component: () => import("../views/FileOrganizer.vue"),
      meta: {
        permissionsAny: ["accessDocumentFolders", "shareDocumentFolders"],
      },
    },
    {
      path: "/extra-hours",
      name: "extra-hours",
      // lazy-loaded
      component: () => import("../views/ExtraHours.vue"),
      meta: {
        permissions: "seeExtraHours",
      },
    },
    // Now an item of the «Aprovações» hub.
    {
      path: "/extra-hours-approve",
      redirect: (to) => ({ path: "/approvals", query: { ...to.query, dom: "horasExtra" } }),
    },
    // Now an item of the «Aprovações» hub.
    {
      path: "/extra-hours-process",
      redirect: (to) => ({ path: "/approvals", query: { ...to.query, dom: "processarHorasExtra" } }),
    },
    {
      path: "/training/:trainingId/userEvaluation/user/:userId",
      name: "training-userEvaluation",
      // lazy-loaded
      component: () => import("../views/TrainingUserEvaluation.vue"),
    },
    // Now an item of the «Aprovações» hub.
    {
      path: "/booking/unavailability/toApprove",
      redirect: (to) => ({ path: "/approvals", query: { ...to.query, dom: "indisponibilidades" } }),
    },
    {
      path: "/booking/unavailability",
      name: "booking-unavailability",
      // lazy-loaded
      component: () => import("../views/Unavailability.vue"),
    },
    {
      path: "/expiringContracts",
      name: "expiringContracts",
      // lazy-loaded
      component: () => import("../views/ExpiringContracts.vue"),
    },
    {
      path: "/costAssistence",
      name: "costAssistence",
      // lazy-loaded
      component: () => import("../views/CostAssistence.vue"),
      meta: {
        permissions: "seeCostAssistence",
      },
    },
    // Now an item of the «Aprovações» hub.
    {
      path: "/costAssistenceAdmin",
      redirect: (to) => ({ path: "/approvals", query: { ...to.query, dom: "ajudasCusto" } }),
    },
    {
      path: "/costAssistenceDetails/:costAssistenceId/details",
      name: "costAssistenceDetails",
      // lazy-loaded
      component: () => import("../views/CostAssistenceDetail.vue"),
      meta: {
        permissions: "seeCostAssistence",
      },
    },
    {
      path: "/costAssistenceDetails/:type/month/:month/year/:year/user/:userId",
      name: "createCostAssistence",
      // lazy-loaded
      component: () => import("../views/CostAssistenceDetail.vue"),
      meta: {
        permissions: "seeCostAssistence",
      },
    },
    {
      path: "/hours-report",
      name: "hours-report",
      // lazy-loaded
      component: () => import("../views/HoursReport.vue"),
      meta: {
        permissions: "seeHoursReport",
      },
    },
    {
      path: "/externalContacts",
      name: "externalContacts",
      // lazy-loaded
      component: () => import("../views/ExternalContacts.vue"),
      meta: {
        permissions: "manageExternalContacts",
      },
    },
    {
      path: "/external-contact-teams",
      name: "external-contact-teams",
      // lazy-loaded
      component: () => import("../views/ExternalContactTeams.vue"),
      meta: {
        permissions: "viewExternalContactTeams",
      },
    },
    {
      path: "/expiringContractsEmailsTemplates",
      name: "expiringContractsEmailsTemplates",
      // lazy-loaded
      component: () => import("../views/ExpiringContractsEmailsTemplates.vue"),
      meta: {
        permissions: "seeExpiringContractsEmailTemplates",
      },
    },
    {
      path: "/invoicesManagement",
      name: "invoicesManagement",
      // lazy-loaded
      component: () => import("../views/InvoicesManagement.vue"),
      meta: {
        permissions: "seeInvoicesManagement",
        tabLabel: "Gestão de Cobranças",
        // Full browser title; overrides the global "<label> | W4M" pattern.
        pageTitle: "Gestão de Cobranças | W4M Solutions",
      },
    },
    {
      path: "/invoicesManagement/emailTemplates",
      name: "invoiceReminderEmailTemplates",
      // lazy-loaded
      component: () => import("../views/InvoiceReminderEmailTemplates.vue"),
      // One page for every billing company: the page itself offers the ones
      // the user may edit (see mixins/invoicesCompanyPicker.js).
      meta: {
        permissionsAny: [
          "seeInvoiceReminderEmailTemplates",
          "seeEcomoveInvoiceReminderEmailTemplates",
        ],
        tabLabel: "Templates de Emails de Faturas",
      },
    },
    // The same pages for the Ecomove: `props.company` picks the API prefix,
    // storage keys and aliases (see config/invoicesCompanies.js).
    {
      path: "/ecomove/invoicesManagement",
      name: "ecomoveInvoicesManagement",
      // lazy-loaded
      component: () => import("../views/InvoicesManagement.vue"),
      props: { company: "ecomove" },
      meta: {
        permissions: "seeEcomoveInvoicesManagement",
        tabLabel: "Gestão de Cobranças Ecomove",
        pageTitle: "Gestão de Cobranças | Ecomove",
      },
    },
    {
      path: "/clientEmails",
      name: "clientEmailsManagement",
      // lazy-loaded
      component: () => import("../views/ClientEmailsManagement.vue"),
      meta: {
        permissionsAny: ["manageClientEmails", "manageEcomoveClientEmails"],
        tabLabel: "Emails de Clientes",
      },
    },
    {
      path: "/customerOrdersManagement",
      name: "customerOrdersManagement",
      // lazy-loaded
      component: () => import("../views/CustomerOrdersManagement.vue"),
      meta: {
        permissions: "seeCustomerOrdersManagement",
        tabLabel: "Gestão de Encomendas de Clientes",
        pageTitle: "Gestão de Encomendas de Clientes | W4M Solutions",
      },
    },
    {
      path: "/customerOrdersManagement/emailTemplates",
      name: "customerOrderEmailTemplates",
      // lazy-loaded
      component: () => import("../views/CustomerOrderEmailTemplates.vue"),
      meta: {
        permissions: "seeCustomerOrderEmailTemplates",
        tabLabel: "Templates de Emails de Encomendas",
      },
    },
    {
      path: "/surveyReportConfigs",
      name: "surveyReportConfigs",
      // lazy-loaded
      component: () => import("../views/SurveyReportConfigs.vue"),
      meta: {
        permissions: "seeReportSurveyConfig",
      },
    },
    {
      path: "/surveyReportConfigs/:id/sentEmails",
      name: "surveyReportSentEmails",
      // lazy-loaded
      component: () => import("../views/SurveyReportSentEmails.vue"),
      meta: {
        permissions: "seeReportSurveyConfig",
      },
    },
    {
      path: "/administration/indicators",
      name: "indicatorsManagement",
      meta: {
        tabLabel: "Gestão de Indicadores",
        permissions: "manageIndicators",
      },
      component: () => import("../views/IndicatorsManagement.vue"),
    },
    {
      path: "/administration/indicators/groups",
      name: "indicatorGroups",
      meta: {
        tabLabel: "Grupos de Indicadores",
        permissions: "manageIndicators",
      },
      component: () => import("../views/IndicatorGroups.vue"),
    },
    {
      path: "/indicators",
      name: "indicators",
      meta: {
        tabLabel: "Os Meus Indicadores",
      },
      component: () => import("../views/Indicators.vue"),
    },
    {
      path: "/administration/email-history",
      name: "emailHistory",
      // lazy-loaded
      component: () => import("../views/EmailHistory.vue"),
      meta: {
        permissions: "seeEmailHistory",
      },
    },
    {
      path: "/administration/audit-log",
      name: "auditLog",
      // lazy-loaded
      component: () => import("../views/AuditLog.vue"),
      meta: {
        permissions: "seeAuditLog",
      },
    },
    {
      path: "/administration/survey-pricing",
      name: "SurveyPricing",
      // lazy-loaded
      component: () => import("../views/SurveyPricing.vue"),
      meta: {
        permissions: "seeSurveyPricingAdmin",
      },
    },
    {
      path: "/salesObjectives",
      name: "salesObjectives",
      // lazy-loaded
      component: () => import("../views/SalesObjectives.vue"),
      meta: {
        permissions: "seeSalesObjectives",
      },
    },
    {
      path: "/licenseManagement",
      name: "licenseManagement",
      // lazy-loaded
      component: () => import("../views/License.vue"),
      meta: {
        permissions: "seeLicenseManagement",
      },
    },
    {
      path: "/targa-telematics",
      name: "targa-telematics",
      // lazy-loaded
      meta: {
        permissions: "seeTargaTelematics",
      },
      component: () => import("../views/TargaTelematics.vue"),
    },
    {
      path: "/targa-telematics-vehical-details/:id",
      name: "targa-telematics-vehical-details",
      meta: {
        permissions: "seeTargaTelematics",
      },
      // lazy-loaded
      component: () => import("../views/TargaTelematicsVehicalDetails.vue"),
    },
    {
      path: "/fleet-unlinked-trips",
      name: "fleet-unlinked-trips",
      meta: {
        permissions: "seeFleetUnlinkedTrips",
      },
      // lazy-loaded
      component: () => import("../views/FleetUnlinkedTrips.vue"),
    },
    {
      path: "/equipmentWithoutLocation",
      name: "equipmentWithoutLocation",
      // lazy-loaded
      component: () => import("../views/EquipmentWithoutLocation.vue"),
      meta: {
        permissions: "seeEquipmentWithoutLocation",
      },
    },
    {
      path: "/reports/equipment-map",
      name: "equipmentMap",
      // lazy-loaded
      component: () => import("../views/EquipmentMap.vue"),
      meta: {
        permissions: "seeEquipmentMap",
        tabLabel: "Equipamentos Instalados",
      },
    },
    {
      path: "/licensesToProcess",
      name: "licensesToProcess",
      // lazy-loaded
      component: () => import("../views/LicensesToProcess.vue"),
      meta: {
        permissions: "seeLicensesToProcess",
      },
    },
    {
      path: "/inactiveContractsWithActiveEquipments",
      name: "inactiveContractsWithActiveEquipments",
      // lazy-loaded
      component: () =>
        import("../views/InactiveContractsWithActiveEquipments.vue"),
      meta: {
        permissions: "seeInactiveContractsWithActiveEquipments",
      },
    },
    {
      path: "/commercial-hub",
      name: "commercialHub",
      // lazy-loaded
      component: () => import("../views/CommercialHub.vue"),
      meta: {
        permissions: "seeCommercialHub",
        tabLabel: "Hub Comercial",
      },
    },
    {
      path: "/financial-hub",
      name: "financialHub",
      // lazy-loaded
      component: () => import("../views/FinancialHub.vue"),
      meta: {
        permissions: "seeFinancialHub",
        tabLabel: "Hub Financeiro",
      },
    },
    // The same hub for the Ecomove: `props.company` picks the API prefix
    // (see config/invoicesCompanies.js).
    {
      path: "/ecomove/financial-hub",
      name: "ecomoveFinancialHub",
      // lazy-loaded
      component: () => import("../views/FinancialHub.vue"),
      props: { company: "ecomove" },
      meta: {
        permissions: "seeEcomoveFinancialHub",
        tabLabel: "Hub Financeiro Ecomove",
        pageTitle: "Hub Financeiro | Ecomove",
      },
    },
    {
      path: "/commercialReport",
      name: "commercialReport",
      // lazy-loaded
      component: () => import("../views/CommercialReport.vue"),
      meta: {
        permissions: "seeComercialReport",
        twoFa: true,
      },
    },
    {
      path: "/commissions-consultation",
      name: "commissionsConsultation",
      // lazy-loaded
      component: () => import("../views/CommissionsConsultation.vue"),
      meta: {
        permissions: "seeCommissionsReport",
        twoFa: true,
      },
    },
    {
      path: "/contracts/list",
      name: "contractsList",
      // lazy-loaded
      component: () => import("../views/ContractsList.vue"),
      meta: {
        permissions: "seeContractsList",
      },
    },
    {
      path: "/operational-management/entities",
      name: "operationalEntitiesList",
      component: () => import("../views/OperationalEntitiesPage.vue"),
      meta: {
        permissions: "seeOperationalManagementMenu",
      },
    },
    {
      path: "/operational-management/entities/:entityId",
      name: "operationalEntityDetails",
      component: () => import("../views/OperationalEntityDetails.vue"),
      meta: {
        permissions: "seeOperationalManagementMenu",
      },
    },
    {
      path: "/operational-management/locals",
      name: "operationalLocationsList",
      component: () => import("../views/OperationalLocationsPage.vue"),
      meta: {
        permissions: "seeOperationalManagementMenu",
      },
    },
    {
      path: "/operational-management/locals/:locationId",
      name: "operationalLocationDetails",
      component: () => import("../views/OperationalLocationDetails.vue"),
      meta: {
        permissions: "seeOperationalManagementMenu",
      },
    },
    {
      path: "/operational-management/survey-pats",
      name: "surveyPatsList",
      component: () => import("../views/SurveyAreas.vue"),
      meta: {
        permissions: "seeSurveyPatsList",
      },
    },
    {
      path: "/contracts/details/:id",
      name: "contractDetails",
      // lazy-loaded
      component: () => import("../views/ContractDetails.vue"),
      meta: {
        permissions: "seeContractsList",
      },
    },
    {
      path: "/contracts/withoutSellerValidation",
      name: "contractsWithoutSellerValidation",
      // lazy-loaded
      component: () => import("../views/ContractsWithoutSellerValidation.vue"),
      meta: {
        permissions: "seeComercialReport",
        twoFa: true,
      },
    },
    {
      path: "/business/withoutContract",
      name: "businessWithoutContract",
      // lazy-loaded
      component: () => import("../views/BusinessWithoutContract.vue"),
      meta: {
        permissions: "seeComercialReport",
        twoFa: true,
      },
    },
    {
      path: "/business/soldAdjudicated/installedWithoutPO",
      name: "businessSoldAdjudicatedInstalledWithoutPO",
      component: () => import("../views/BusinessSoldAdjudicated.vue"),
      meta: { permissions: "seeComercialReport", twoFa: true },
    },
    {
      path: "/business/soldAdjudicated/installedWithoutPO/:sellerId?",
      name: "businessSoldAdjudicatedInstalledWithoutPOSeller",
      component: () => import("../views/BusinessSoldAdjudicated.vue"),
      meta: { permissions: "seeComercialReport", twoFa: true },
    },
    {
      path: "/business/soldAdjudicated/installedWithPO",
      name: "businessSoldAdjudicatedInstalledWithPO",
      component: () => import("../views/BusinessSoldAdjudicated.vue"),
      meta: { permissions: "seeComercialReport", twoFa: true },
    },
    {
      path: "/business/soldAdjudicated/installedWithPO/:sellerId?",
      name: "businessSoldAdjudicatedInstalledWithPOSeller",
      component: () => import("../views/BusinessSoldAdjudicated.vue"),
      meta: { permissions: "seeComercialReport", twoFa: true },
    },
    {
      path: "/business/soldAdjudicated/notInstalledWithPO",
      name: "businessSoldAdjudicatedNotInstalledWithPO",
      component: () => import("../views/BusinessSoldAdjudicated.vue"),
      meta: { permissions: "seeComercialReport", twoFa: true },
    },
    {
      path: "/business/soldAdjudicated/notInstalledWithPO/:sellerId?",
      name: "businessSoldAdjudicatedNotInstalledWithPOSeller",
      component: () => import("../views/BusinessSoldAdjudicated.vue"),
      meta: { permissions: "seeComercialReport", twoFa: true },
    },
    {
      path: "/business/soldAdjudicated/notInstalledWithoutPO",
      name: "businessSoldAdjudicatedNotInstalledWithoutPO",
      component: () => import("../views/BusinessSoldAdjudicated.vue"),
      meta: { permissions: "seeComercialReport", twoFa: true },
    },
    {
      path: "/business/soldAdjudicated/notInstalledWithoutPO/:sellerId?",
      name: "businessSoldAdjudicatedNotInstalledWithoutPOSeller",
      component: () => import("../views/BusinessSoldAdjudicated.vue"),
      meta: { permissions: "seeComercialReport", twoFa: true },
    },
    {
      path: "/business/installedBilled/:sellerId",
      name: "businessInstalledBilled",
      component: () => import("../views/BusinessInstalledBilled.vue"),
      meta: { permissions: "seeInstalledBilled", twoFa: true },
    },
    {
      path: "/business/receivableBalances/:sellerId",
      name: "businessReceivableBalances",
      component: () => import("../views/BusinessReceivableBalances.vue"),
      meta: { permissions: "seeReceivableBalances", twoFa: true },
    },
    {
      path: "/reports/clients-total-debts",
      name: "clientsTotalDebtsReport",
      // lazy-loaded
      component: () => import("../views/ClientsTotalDebtsReport.vue"),
      meta: { permissions: "seeClientsTotalDebtsReport", twoFa: true },
    },
    {
      path: "/reports/clients-collection",
      name: "clientsCollectionReport",
      // lazy-loaded
      component: () => import("../views/ClientsCollectionReport.vue"),
      meta: { permissions: "seeClientsCollectionReport", twoFa: true },
    },
    {
      path: "/reports/outstanding-invoices",
      name: "outstandingInvoicesReport",
      // lazy-loaded
      component: () => import("../views/OutstandingInvoicesReport.vue"),
      meta: {
        permissions: "seeOutstandingInvoicesReport",
        twoFa: true,
        tabLabel: "Faturado por Receber",
      },
    },
    {
      path: "/reports/received-invoices",
      name: "receivedInvoicesReport",
      // lazy-loaded
      component: () => import("../views/ReceivedInvoicesReport.vue"),
      meta: {
        permissions: "seeReceivedInvoicesReport",
        twoFa: true,
        tabLabel: "Faturado Recebido",
      },
    },
    {
      path: "/reports/unbilled-adjudicated-deals",
      name: "unbilledAdjudicatedDealsReport",
      // lazy-loaded
      component: () => import("../views/UnbilledAdjudicatedDealsReport.vue"),
      meta: {
        permissions: "seeUnbilledAdjudicatedDealsReport",
        twoFa: true,
        tabLabel: "Não Faturado (Adjudicado)",
      },
    },
    {
      path: "/reports/partially-invoiced-sold-deals",
      name: "partiallyInvoicedSoldDealsReport",
      // lazy-loaded
      component: () => import("../views/PartiallyInvoicedSoldDealsReport.vue"),
      meta: {
        permissions: "seePartiallyInvoicedSoldDealsReport",
        twoFa: true,
        tabLabel: "Vendidos Fat. Parcialmente",
      },
    },
    {
      path: "/reports/renting-deals",
      name: "rentingDealsReport",
      // lazy-loaded
      component: () => import("../views/RentingDealsReport.vue"),
      meta: {
        permissions: "seeRentingDealsReport",
        twoFa: true,
        tabLabel: "Em Renting",
      },
    },
    {
      path: "/reports/installed-without-po-deals",
      name: "installedWithoutPoDealsReport",
      // lazy-loaded
      component: () => import("../views/InstalledWithoutPoDealsReport.vue"),
      meta: {
        permissions: "seeInstalledWithoutPoDealsReport",
        twoFa: true,
        tabLabel: "Instalado Sem PO",
      },
    },
    {
      path: "/reports/installed-with-po-deals",
      name: "installedWithPoDealsReport",
      // lazy-loaded
      component: () => import("../views/InstalledWithPoDealsReport.vue"),
      meta: {
        permissions: "seeInstalledWithPoDealsReport",
        twoFa: true,
        tabLabel: "Instalado Com PO",
      },
    },
    {
      path: "/reports/not-installed-with-po-deals",
      name: "notInstalledWithPoDealsReport",
      // lazy-loaded
      component: () => import("../views/NotInstalledWithPoDealsReport.vue"),
      meta: {
        permissions: "seeNotInstalledWithPoDealsReport",
        twoFa: true,
        tabLabel: "Não Instalado Com PO",
      },
    },
    {
      path: "/reports/not-installed-without-po-deals",
      name: "notInstalledWithoutPoDealsReport",
      // lazy-loaded
      component: () => import("../views/NotInstalledWithoutPoDealsReport.vue"),
      meta: {
        permissions: "seeNotInstalledWithoutPoDealsReport",
        twoFa: true,
        tabLabel: "Não Instalado Sem PO",
      },
    },
    {
      path: "/reports/contracts-pending-renewal",
      name: "contractsPendingRenewalReport",
      // lazy-loaded
      component: () => import("../views/ContractsPendingRenewalReport.vue"),
      meta: {
        permissions: "seeContractsPendingRenewalReport",
        twoFa: true,
        tabLabel: "Contratos Ativar/Renovar",
      },
    },
    {
      path: "/reports/sales-by-seller",
      name: "salesBySellerReport",
      // lazy-loaded
      component: () => import("../views/SalesBySellerReport.vue"),
      meta: {
        permissionsAny: [
          "seeSalesMonthlyFeesBySellerReport",
          "seeSalesSetupBySellerReport",
          "seeSalesAnnualBySellerReport",
        ],
        twoFa: true,
      },
    },
    // The three reports used to be three pages; the redirects keep bookmarks
    // and links working, each one landing on its own section of the merged
    // page.
    {
      path: "/reports/sales-monthly-fees-by-seller",
      redirect: (to) => ({
        name: "salesBySellerReport",
        query: { ...to.query, view: "mensalidades" },
      }),
    },
    {
      path: "/reports/sales-setup-by-seller",
      redirect: (to) => ({
        name: "salesBySellerReport",
        query: { ...to.query, view: "setup" },
      }),
    },
    {
      path: "/reports/sales-annual-by-seller",
      redirect: (to) => ({
        name: "salesBySellerReport",
        query: { ...to.query, view: "anual" },
      }),
    },
    {
      path: "/reports/annual-sales-comparison",
      name: "annualSalesComparisonReport",
      // lazy-loaded
      component: () => import("../views/AnnualSalesComparisonReport.vue"),
      meta: { permissions: "seeAnnualSalesComparisonReport", twoFa: true },
    },
    {
      path: "/reports/revenue-cost-categories",
      name: "revenueCostCategoriesReport",
      // lazy-loaded
      component: () => import("../views/RevenueCostCategoriesReport.vue"),
      meta: { permissions: "seeRevenueCostCategoriesReport", twoFa: true },
    },
    {
      path: "/reports/recurring-revenue-clients",
      name: "recurringRevenueClientsReport",
      // lazy-loaded
      component: () => import("../views/RecurringRevenueClientsReport.vue"),
      meta: { permissions: "seeRecurringRevenueClientsReport", twoFa: true },
    },
    {
      path: "/reports/expenses",
      name: "expensesReport",
      // lazy-loaded
      component: () => import("../views/ExpensesReport.vue"),
      meta: { permissions: "seeExpensesReport", twoFa: true },
    },
    {
      path: "/reports/approved-expenses-by-employee",
      name: "approvedExpensesByEmployeeReport",
      // lazy-loaded
      component: () => import("../views/ApprovedExpensesByEmployeeReport.vue"),
      meta: { permissions: "seeApprovedExpensesReport", twoFa: true },
    },
    {
      path: "/reports/support-contracts",
      name: "supportContractsReport",
      // lazy-loaded
      component: () => import("../views/SupportContractsReport.vue"),
      meta: { permissions: "seeSupportContractsReport", twoFa: true },
    },
    {
      path: "/reports/support-contracts-forecast",
      name: "supportContractsForecastReport",
      // lazy-loaded
      component: () => import("../views/SupportContractsForecastReport.vue"),
      meta: { permissions: "seeSupportContractsReport", twoFa: true },
    },
    {
      path: "/reports/maintenance-contracts-by-management",
      name: "maintenanceContractsByManagementReport",
      // lazy-loaded
      component: () =>
        import("../views/MaintenanceContractsByManagementReport.vue"),
      meta: {
        permissions: "seeMaintenanceContractsByManagementReport",
        twoFa: true,
      },
    },
    {
      path: "/reports/supplier-debts",
      name: "supplierDebtsReport",
      // lazy-loaded
      component: () => import("../views/SupplierDebtsReport.vue"),
      meta: { permissions: "seeSupplierDebtsReport", twoFa: true },
    },
    {
      path: "/reports/supplier-purchases",
      name: "supplierPurchasesReport",
      // lazy-loaded
      component: () => import("../views/SupplierPurchasesReport.vue"),
      meta: { permissions: "seeSupplierPurchasesReport", twoFa: true },
    },
    {
      path: "/reports/contracts-vs-gains",
      name: "contractsVsGainsReport",
      // lazy-loaded
      component: () => import("../views/ContractsVsGainsReport.vue"),
      meta: { permissions: "seeContractsVsGainsReport", twoFa: true },
    },
    {
      path: "/reports/dossiers-vs-forecast",
      name: "dossiersVsForecastReport",
      // lazy-loaded
      component: () => import("../views/DossiersVsForecastReport.vue"),
      meta: { permissions: "seeDossiersVsForecastReport", twoFa: true },
    },
    {
      path: "/reports/sales-contracts-by-segment",
      name: "salesContractsBySegmentReport",
      // lazy-loaded
      component: () => import("../views/SalesContractsBySegmentReport.vue"),
      meta: { permissions: "seeSalesContractsBySegmentReport", twoFa: true },
    },
    {
      // The segment label is the parameter, percent-encoded: it is free text
      // carrying accents, spaces and punctuation.
      path: "/reports/sales-contracts-by-segment/:segment",
      name: "sales-contracts-by-segment-detail",
      // lazy-loaded
      component: () => import("../views/ClientsBySegmentReport.vue"),
      meta: { permissions: "seeSalesContractsBySegmentReport", twoFa: true },
    },
    {
      path: "/2fa/verify",
      name: "two-fa-verify",
      meta: {
        tabLabel: "Verificação 2FA",
      },
      component: () => import("@/components/TwoFA/TwoFAVerify.vue"),
    },
    {
      path: "/2fa/setup",
      name: "two-fa-setup",
      meta: {
        tabLabel: "Configuração 2FA",
      },
      component: () => import("@/components/TwoFA/TwoFASetup.vue"),
    },
    {
      path: "/2fa",
      name: "two-fa",
      meta: {
        tabLabel: "Autenticação 2FA",
      },
      component: () => import("@/components/TwoFA/TwoFA.vue"),
    },
    {
      path: "/forbidden",
      name: "forbidden",
      meta: {
        tabLabel: "Sem permissão",
      },
      component: () => import("@/views/Forbidden.vue"),
    },
    {
      path: "/tokens-access",
      name: "tokens-access",
      meta: {
        permissions: "manageTokensAccessMenu",
      },
      component: () => import("@/views/TokenAccess.vue"),
    },
    {
      path: "/product-changes",
      name: "product-changes",
      meta: {
        permissions: "approveProductChanges",
      },
      component: () => import("@/views/ProductChangesApprove.vue"),
    },
    {
      // Kilo Gateway credential, AI Maestro and Bootstrap RAG settings
      path: "/admin/ai",
      name: "ai-integrations",
      meta: {
        permissions: "manageKiloAuthentication",
      },
      component: () => import("@/views/KiloAuthentication.vue"),
    },
    {
      // The page used to be "Autenticação Kilo"; old bookmarks still work
      path: "/kilo-authentication",
      redirect: { name: "ai-integrations" },
    },
    {
      path: "/admin/knowledge-base",
      name: "knowledge-base",
      meta: {
        permissions: "managePatKnowledgeBase",
      },
      component: () => import("@/views/KnowledgeBase.vue"),
    },
    {
      path: "/document-management",
      name: "document-management",
      meta: {
        permissions: "seeDocumentManagement",
        tabLabel: "Base Documental",
      },
      component: () => import("@/views/DocumentManagement.vue"),

    },
    {
      path: "/internal-documents",
      name: "internal-documents",
      component: () => import("@/views/InternalDocuments.vue"),

    },
    {
      path: "/shared-documents",
      name: "shared-documents",
      component: () => import("@/views/SharedFiles.vue"),
    },
    {
      path: "/rgpd-documents",
      name: "rgpd-documents",
      component: () => import("@/views/RGPDDocuments.vue"),
    },
    {
      path: "/fleet-user-documents",
      name: "fleet-user-documents",
      component: () => import("@/views/FleetUserDocuments.vue"),
    },
    {
      path: "/internal-dossiers",
      name: "internalDossiers",
      // lazy-loaded
      component: () => import("@/views/internal-dossiers/InternalDossiers.vue"),
      meta: {
        permissions: "seeInternalDossiers",
      },
    },
    {
      path: "/internal-dossiers/create",
      name: "InternalDossiersFormView",
      // lazy-loaded
      component: () => import("@/views/internal-dossiers/InternalDossiersFormView.vue"),
      meta: {
        permissions: "seeAddEditInternalDossiers",
      },
    },
    {
      path: "/internal-dossiers/update/:type/:id",
      name: "InternalDossiersFormUpdateView",
      // lazy-loaded
      component: () => import("@/views/internal-dossiers/InternalDossiersFormView.vue"),
      meta: {
        permissions: "seeAddEditInternalDossiers",
      },

    },
    {
      path: "/transport-documents/locations",
      name: "TransportDocumentsLocations",
      component: () => import("@/views/transport-documents/TransportDocumentLocations.vue"),
      meta: {
        requiresAuth: true,
        permissions: "seeTransportDocumentsLocations",
      },
    },
    {
      path: "/task-board",
      name: "task-board",
      component: () => import("../views/TaskBoard.vue"),
      meta: {
        requiresAuth: true,
        // Vehicle-access ACLs only reach the Frota board (scoped by the API).
        permissionsAny: ["canAccessTaskboard", "taskboardFullAccess", "seeFleetVehicleDetails", "frotaTicketsManage"],
      },
    },
    {
      path: "/task-board/projects",
      name: "task-board-projects",
      component: () => import("../views/TaskBoardProjects.vue"),
      meta: {
        requiresAuth: true,
        permissionsAny: ["canAccessTaskboard", "taskboardFullAccess", "canCreateTaskboardProjects"],
      },
    },
    {
      path: "/task-board/manage-project/:id",
      name: "task-board-manage-project",
      component: () => import("../views/TaskBoardManageProject.vue"),
      meta: {
        requiresAuth: true,
        permissionsAny: ["canAccessTaskboard", "taskboardFullAccess", "canCreateTaskboardProjects"],
      },
    },
    {
      path: "/installations-task-board",
      name: "installations-task-board",
      component: () => import("../views/InstallationsTaskBoard.vue"),
      meta: {
        requiresAuth: true,
        permissionsAny: ["viewInstallationsTaskboard", "manageInstallationsTaskboard"],
      },
    },
    {
      path: "/installation-planner",
      name: "installation-planner",
      component: () => import("../views/InstallationPlanner.vue"),
      meta: {
        requiresAuth: true,
        permissionsAny: ["manageInstallationPlanner"],
      },
    },
  ],
});

// Navigation guard to check authentication and permissions
router.beforeEach(async (to, from, next) => {
  if (config.maintenanceMode === 'true' || config.maintenanceMode === true) {
    if (to.path !== '/maintenance') {
      return next('/maintenance');
    }
    return next();
  }

  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && (!loggedIn || loggedIn == null)) {
    next("/login");
  } else {
    var userPermissions = [];
    if (loggedIn != undefined && JSON.parse(loggedIn).moreInfo != undefined) {
      userPermissions = loggedIn
        ? JSON.parse(window.atob(JSON.parse(loggedIn).moreInfo))
        : [];
      if (to.meta.permissions) {
        let isAllowed = userPermissions.find(
          (acl) => acl === to.meta.permissions
        );

        if (!isAllowed) {
          return next("/");
        }
      }
      if (
        Array.isArray(to.meta.permissionsAny) &&
        to.meta.permissionsAny.length > 0
      ) {
        const isAllowed = to.meta.permissionsAny.some((permission) =>
          userPermissions.includes(permission)
        );

        if (!isAllowed) {
          return next("/");
        }
      }
    }
    if (to.meta.twoFa === true) {
      try {
        // save current route to redirect after 2FA
        localStorage.setItem("after2fa", to.path);

        const status = await TwoFAService.status();
        if (!status || !status.data) {
          // Status call failed → let the 2FA dispatcher decide
          return next("/2fa");
        }

        if (!status.data.enabled) {
          // User hasn't activated 2FA yet → redirect to setup
          return next("/2fa/setup");
        }

        // checkSession() resolves to null both on 419 (verification older
        // than the backend's 120-minute window) and on any other failure.
        // Either way the user has to re-validate — an expected flow, not
        // an error.
        const check = await TwoFAService.checkSession();
        if (!check) {
          // 2FA session not validated → redirect to verification
          return next("/2fa");
        }
      } catch (e) {
        console.error("Error validating 2FA in router:", e);
        return next("/2fa");
      }
    }
    next();
  }
});

router.afterEach(() => {
  sessionStorage.removeItem("chunkLoadReload");
});

router.onError((error) => {
  const isChunkLoadError =
    error.name === "ChunkLoadError" ||
    /loading chunk \S+ failed/i.test(error.message);

  if (!isChunkLoadError) {
    return;
  }

  // A stale cached index.html can keep pointing to chunk hashes that no
  // longer exist after a new deploy. A plain reload() can still be served
  // from the browser's cache, so force a fresh request with a cache-busting
  // query param. Guard with sessionStorage to avoid an infinite reload loop
  // if the failure isn't actually caused by a stale cache.
  if (sessionStorage.getItem("chunkLoadReload")) {
    sessionStorage.removeItem("chunkLoadReload");
    return;
  }
  sessionStorage.setItem("chunkLoadReload", "1");

  const url = new URL(window.location.href);
  url.searchParams.set("_cb", Date.now());
  window.location.replace(url.toString());
});
